import { z } from 'zod';

const approveGrammarPointsV1RequestSchemaDefinition = z.object({
  ids: z.array(z.number().int().positive()).min(1),
  approved: z.boolean(),
});

export const approveGrammarPointsV1RequestSchema: typeof approveGrammarPointsV1RequestSchemaDefinition =
  approveGrammarPointsV1RequestSchemaDefinition;

export type IApproveGrammarPointsV1Request = z.infer<typeof approveGrammarPointsV1RequestSchema>;
